export default "__VITE_ASSET__CusTuZ2X__"